module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_3009.5e275777.png";